import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OrderByPipe } from './../../../../shared/pipe/order-by.pipe';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../../core/services/event.service';
import { UtilityService } from '../../../../core/services/utility.service';

@Component({
  selector: 'app-manage-mileage-rate-modal',
  templateUrl: './manage-mileage-rate-modal.component.html',
  styleUrls: ['./manage-mileage-rate-modal.component.css']
})
export class ManageMileageRateModalComponent implements OnInit {
  formData: { [key: string]: any } = {};
  rateList: any;
  lastSave: { [key: string]: any } = {};
  labelFade: any;

  constructor(private utilityService: UtilityService, private employeeService: EmployeeService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.getRate()
  }

  public getRate() {
    this.employeeService.getMileageRate().then((response: any) => {
      this.rateList = response;
    })
  }

  public deleteTrigger(data, type) {
    if (type == "yes")
      data.deleteTrigger = true;
    else
      data.deleteTrigger = false;
  }

  public addEditCat(data?: any) {
    this.employeeService.addEditMileageRate((data == null ? -1 : data.ExpenseMileageRateID), (data == null ? this.formData.newRate : data.MileageRate), (data == null ? this.formData.newDescription : data.RateDescription), (data == null ? this.formData.newPRCo : data.PRCo)).then((response: any) => {
      this.saveLabel(response.success);
      this.formData.newRate = null;
      this.formData.newDescription = null;
      this.formData.newPRCo = null;
      this.getRate();
    })
  }

  public deleteCat(data) {
    this.employeeService.deleteMileageRate(data.ExpenseMileageRateID).then((response: any) => {
      this.saveLabel(response.success);
      this.getRate();
    })
  }

  public saveLabel(status: boolean) {
    this.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.labelFade = true;
    }, 2000);
  }

  public closeClicked() {
    this.activeModal.close();
  }
}
